import {useEffect, useState} from 'react';
import MetaDataCheckerService from '../../Service/AssetService/MetaDataCheckerService';
import {useTaopix} from '../../Components/Context/TaopixContext';
import useSettings from '../useSettings';
import {useSelector} from 'react-redux';
import {AssetServicesSelector} from '../../Selectors';

const useMetaDataChecker = () => {
  const app = useTaopix();
  const settings = useSettings();
  // pull in the asset services
  const assetServices = useSelector(AssetServicesSelector);

  const [api, setAPI] = useState<MetaDataCheckerService>();

  useEffect(() => {
    setAPI(
      new MetaDataCheckerService(
        app.core.get('server'),
        assetServices,
        settings.state?.keySettings?.groupCode
      )
    );
  }, [assetServices, settings.state?.keySettings?.groupCode]);

  return api;
};

export default useMetaDataChecker;
